<div
  *ngVar="(isEditing$ | async) as isEditing"
  cdkDropList
  class="faqs-container flex flex-col w-full gap-5"
  (cdkDropListDropped)="changeOrder($event)">
  @if (isEditing) {
    <app-faq class="add-faq-btn" [isEditing]="true"></app-faq>
  }

  @for (faq of faqs; track faq.id) {
    @if (isFaqDraggable(faq, isEditing)) {
      <div
        class="faq-container relative"
        cdkDrag
        [cdkDragLockAxis]="'y'"
        [cdkDragBoundary]="'.faqs-container'">
        <ng-container *ngTemplateOutlet="faqItem; context: { faq, isEditing }"></ng-container>

        <app-new-button
          #button
          cdkDragHandle
          class="drag-icon cdk-drag-handle absolute top-0 left-0 h-10 w-10 bg-navy-40 border border-navy-60 transform -translate-x-1/2 -translate-y-1/2"
          [svgIconPath]="'drag'"
          [isOnlyIcon]="true"
          [type]="'basic'"
          [size]="'tiny'">
        </app-new-button>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="faqItem; context: { faq, isEditing }"></ng-container>
    }
  }
</div>

<ng-template #faqItem let-faq="faq" let-isEditing="isEditing">
  <app-faq class="faq" [faq]="faq" [isEditing]="isEditing"></app-faq>
</ng-template>
